export default __webpack_public_path__ + "static/media/logo.42f4c0e4.png";